<div class="layout-content">
<form (ngSubmit)="submit()" [formGroup]="addTicketForm">
		<div class="grid">
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.note, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.note, 'label')">{{ 'REQUEST_COMMENT' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.note, 'borderInput')">
						<input type="text" pInputText
								[ngClass]="dynamicInputTextDesktopTabletWidth()"
								id="support-input-requestComment"
								formControlName="note" maxlength="220"
								placeholder="{{ 'REQUEST_COMMENT' | translate }}"/>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.note)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div [ngClass]="col12Responsive()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.site,'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.site,'label')">{{ 'SITE' | translate }}</div>
						<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.site,'borderInput')">
							<p-dropdown [options]="sites" formControlName="site"
								placeholder="{{ 'SITE' | translate }}" 
								optionDisabled="Disabled" appendTo="body"
								dataKey="Id"
								scrollHeight="140px"
								[ngClass]="dynamicInputTextWidth()"
								styleClass="{{ dynamicInputTextWidth() }} pl-5"
								>
								<ng-template pTemplate="selectedItem">
									{{ f.site.value.Name }}
								</ng-template>
								<ng-template let-site pTemplate="item">
									{{ site.Name | truncate:[35] }}
								</ng-template>
							</p-dropdown>
						</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.site)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{ 'REQUIRED' | translate }}</small>
			</div>
			<div [ngClass]="col12Responsive()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.accessDate, 'borderRow')">
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.accessDate, 'label')">{{ 'GRANT_ACCESS' | translate }}</div>
					<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.accessDate, 'borderInput')">
						<p-calendar [showIcon]="true" inputId="icon"
							formControlName="accessDate" appendTo="body"
							placeholder="dd/mm/yyyy" [minDate]="minDate"
							[defaultDate]="minDate" dateFormat="dd/mm/yy"
							[ngClass]="dynamicInputTextWidth()"
							styleClass="{{dynamicInputTextWidth()}}"
							inputStyleClass="pl-6 border-noround-right">
						</p-calendar>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.accessDate)" class="flex align-items-center text-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{ 'REQUIRED' | translate }}</small>
			</div>
		</div>

		<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple
				label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mt-2 mx-1"
				[ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()"
				label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1"
				[ngClass]="dynamicButtonWidth()">
			</button>
		</div>
</form>
</div>
